import classNames from 'classnames';
import React from 'react';
import Style from 'styles/components/func.module.scss';
import FuncSectionBlock from 'components/FuncSectionBlock';
import PcImg from 'images/firstview/pc.png';
import about from 'images/func/about.png';
import faq from 'images/func/faq.png';
import news from 'images/func/news.png';
import storeInfo from 'images/func/storeInfo.png';
import designTmp from 'images/func/designTmp.png';
import freePage from 'images/func/freePage.png';
import payment from 'images/func/payment.png';
import delivery from 'images/func/delivery.png';
import productRegisterImage from 'images/func/productRegisterImage.png';
import productCategoryImage from 'images/func/productCategoryImage.png';
import productVariationImage from 'images/func/productVariationImage.png';
import productPeriodImage from 'images/func/productPeriodImage.png';
import memberPriceImage from 'images/func/memberPriceImage.png';
import privatePublishImage from 'images/func/privatePublishImage.png';
import ageLimitImage from 'images/func/ageLimitImage.png';
import giftSettingImage from 'images/func/giftSettingImage.png';
import bulkPurchaseImage from 'images/func/bulkPurchaseImage.png';
import pointImage from 'images/func/pointImage.png';
import pointSaleImage from 'images/func/pointSaleImage.png';
import timeSaleImage from 'images/func/timeSaleImage.png';
import couponImage from 'images/func/couponImage.png';
import mailMagazineImage from 'images/func/mailMagazineImage.png';
import dashboardImage from 'images/func/dashboardImage.png';
import reviewImage from 'images/func/reviewImage.png';
import secretSiteImage from 'images/func/secretSiteImage.png';
import handDeliveryImage from 'images/func/handDeliveryImage.png';
import orderDataDownloadImage from 'images/func/orderDataDownloadImage.png';
import bulkProductUploadImage from 'images/func/bulkProductUploadImage.png';
// 【通常版】PayPal含む ※来月戻す
// import paymentMethod from 'images/func/paymentMethod.png';
// 【2026年3月版】PayPal休止対応
import paymentMethod from 'images/func/paymentMethod_202603.png';

const TopView = () => {
  return (
    <section className={Style.func}>
      <div className={Style.func__topView}>
        <video
          className={Style.func__topView__background}
          src="/fv_gradation_v2.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
        <div className={Style.func__topView__label}>
          <span className={Style.func__topView__eyebrow}>Everything You Need</span>
          必要な機能は、はじめから全部無料で。<br />
          お店が育ったら、さらに追加も。
        </div>
        <img className={classNames(Style.func__topView__img)} src={PcImg} alt="" />
      </div>
    </section>
  );
}

const shopFeatures = [
  {
    title: 'デザインテンプレート',
    description: 'HTML・CSSの知識がなくても、簡単にショップデザインをつくれます。',
    image: designTmp
  },
  {
    title: 'フリーページ',
    description: 'パーツをお好みに組み合わせて、オリジナルページが作成できます。',
    image: freePage
  },
  {
    title: '配送設定',
    description: '配送方法ごとにサイズ別や地域別に配送料の設定ができます。',
    image: delivery
  },
  {
    title: '決済設定',
    description: '銀行振込や代引き、クレジットカード決済などの決済手段を登録できます。詳しくは、ページ下部をご覧ください。',
    image: payment
  },
  {
    title: 'NEWS機能',
    description: 'ショップの最新情報(お知らせ)を発信できます。',
    image: news
  },
  {
    title: 'FAQ管理',
    description: 'お客様からのよくある質問(FAQ)を作成することができます。',
    image: faq
  },
  {
    title: 'ABOUTページ',
    description: 'お店の紹介や商品・サービスに込める想いなどを伝えるページを作成できます。',
    image: about
  },
  {
    title: 'お店情報',
    description: '特定商取引法や問い合わせ先など、テキストを入力するだけで、ショップ運営に必要なページが設定できます。',
    image: storeInfo
  },
  {
    title: '独自ドメイン設定',
    description: '独自ドメインを設定することで、ショップのURLを自由にカスタマイズできます。※ドメイン取得費用、更新費用などはご負担いただきます。詳細はお問い合わせください。',
    image: storeInfo
  },
];

const productSetup = [
  {
    title: '商品登録',
    description: '商品名や販売価格などを入力するだけで簡単に登録できます。',
    image: productRegisterImage
  },
  {
    title: '商品カテゴリ',
    description: '登録した商品をカテゴリに分けて表示できます。',
    image: productCategoryImage
  },
  {
    title: 'バリエーション',
    description: '色やサイズなどを設定し、商品の選択肢を登録できます。',
    image: productVariationImage
  },
  {
    title: '予約/販売期間',
    description: '商品の予約販売や、販売期間の設定ができます。',
    image: productPeriodImage
  },
  {
    title: '会員限定価格',
    description: '商品ごとにショップの会員限定の販売価格を設定できます。',
    image: memberPriceImage
  },
  {
    title: '限定公開',
    description: '商品の専用URLを知っているお客様にのみ、商品情報を公開することができます。',
    image: privatePublishImage
  },
  {
    title: '年齢制限',
    description: '商品ごとに15歳以上、18歳以上、20歳以上の年齢制限をかけることができます。',
    image: ageLimitImage
  },
  {
    title: 'ギフト設定',
    description: '複数のギフトラッピングの種類や価格を設定することができます。',
    image: giftSettingImage
  },
  {
    title: '定期購入設定',
    description: '商品の定期購入を設定できます。',
    image: productPeriodImage
  },
  {
    title: '販売開始通知',
    description: '商品の販売開始日を設定すると、その日時に通知メールが送信されます。',
    image: news
  },
];

const marketingFeatures = [
  {
    title: 'まとめ買い',
    description: '同一商品を複数個購入した際に割引されるように設定できます。',
    image: bulkPurchaseImage,
  },
  {
    title: 'ポイント',
    description: '商品ごとにポイント付与率を設定することができます。',
    image: pointImage,
  },
  {
    title: 'ポイントセール',
    description: '通常ポイントに追加してポイントを付与することができます。',
    image: pointSaleImage,
  },
  {
    title: 'タイムセール',
    description: '開始・終了日を設定し、割引率(%)を適用することができます。',
    image: timeSaleImage,
  },
  {
    title: 'クーポン',
    description: '会員に割引(%)・値引き(円)クーポンを配布することができます。',
    image: couponImage,
  },
  {
    title: 'メルマガ',
    description: 'タイムセールや新商品の入荷などのメールマガジン（メルマガ）を配信することができます。',
    image: mailMagazineImage,
  },
  {
    title: 'ダッシュボード',
    description: '売上・注文数・平均単価を、月や週などの期間別に確認することができます。',
    image: dashboardImage,
  },
  {
    title: 'レビュー',
    description: '購入者様が、購入した商品の評価・コメントを付けることができます。',
    image: reviewImage,
  },
  {
    title: 'Google自動フィード設定',
    description: 'ショップの商品情報を自動連携し、ショッピング広告や無料リスティングの表示を最新に保つ事ができます。',
    image: dashboardImage,
  },
  {
    title: 'Googleタグマネージャー連携',
    description: '管理画面でGoogleタグマネージャーを簡単に連携する事ができます。',
    image: dashboardImage,
  },
  {
    title: 'Googleサーチコンソール連携',
    description: '管理画面でGoogleサーチコンソールを簡単に連携する事ができます。',
    image: dashboardImage,
  },
  {
    title: 'SNS設定',
    description: 'Instagram、X（旧:Twitter）、Facebookの設定ができます。',
    image: reviewImage,
  },
  {
    title: 'TikTok商品投稿',
    description: 'TikTokに商品情報を自動的に投稿する設定ができます。',
    image: reviewImage,
  },
  {
    title: 'Instagramショップ開設サポート',
    description: 'Instagramショップ開設をサポートいたします。',
    image: reviewImage,
  },
];

const comachiApps = [
  {
    title: 'シークレットサイト',
    description: 'シークレット会員に登録した人だけがショップを閲覧できるように設定することができます。',
    image: secretSiteImage,
  },
  {
    title: '手渡し',
    description: '商品を購入者へ直接手渡しする商品を登録が可能です。',
    image: handDeliveryImage,
  },
  {
    title: '注文データダウンロード',
    description: '注文データをExcelまたはCSV形式でダウンロードすることができます。',
    image: orderDataDownloadImage,
  },
  {
    title: '商品一括登録',
    description: 'CSVファイルに入力した商品情報を一括で登録することができます。',
    image: bulkProductUploadImage,
  }
];

const appsDescreption = "ショップの運営に合わせて、必要なアプリ（一部有料）を追加できます。";

const PaymentMethod = () => {
  return (
    <>
      <section className={Style.storefunc}>
        <div className={Style.paymentMethod} >
          <h2 className={Style.title}>決済手段</h2>
          <img src={paymentMethod} className={Style.paymentMethod__img} alt="決済手段" />
          <div className={Style.paymentMethod__notes}>
            ※クレジットカード決済は「株式会社ゼウス」のサービスです。<br />
            ※PayPay決済は「GMOイプシロン株式会社」のサービスです。<br />
            ※その他、ご利用になられる決済手段に応じて、各決済サービスを提供する会社へお申込みをしていただく必要がございます。
          </div>
        </div>
      </section>
    </>
  );
};


const SectionHeader = ({ eyebrow, title, sub }) => {
  return (
    <div className={Style.sectionHeader}>
      <div className={Style.sectionHeader__eyebrow}>{eyebrow}</div>
      <h2 className={Style.sectionHeader__title}>{title}</h2>
      {sub && <p className={Style.sectionHeader__sub}>{sub}</p>}
      <div className={Style.sectionHeader__line} />
    </div>
  );
};

const ShopSetupSection = () => {
  return (
    <section className={Style.shopSetup}>
      <SectionHeader
        eyebrow="Store Setup"
        title="お店づくり"
        sub="デザインから決済設定まで、あなたのお店に必要なすべてが揃っています。"
      />
      <div className={Style.shopSetup__grid}>
        {shopFeatures.map((item, index) => (
          <div key={index} className={Style.shopSetup__card}>
            <div className={Style.shopSetup__icon}>
              <img src={item.image} alt={item.title} />
            </div>
            <h3 className={Style.shopSetup__cardTitle}>{item.title}</h3>
            <p className={Style.shopSetup__cardDesc}>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

const ProductSetupSection = () => {
  return (
    <section className={Style.productSetup}>
      <SectionHeader
        eyebrow="Product Setup"
        title="商品の準備"
        sub="商品登録からバリエーション設定まで、販売に必要な準備がすべてできます。"
      />
      <div className={Style.productSetup__grid}>
        {productSetup.map((item, index) => (
          <div key={index} className={Style.productSetup__card}>
            <div className={Style.productSetup__icon}>
              <img src={item.image} alt={item.title} />
            </div>
            <div className={Style.productSetup__cardBody}>
              <h3 className={Style.productSetup__cardTitle}>{item.title}</h3>
              <p className={Style.productSetup__cardDesc}>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

const mainFeatures = [
  {
    tag: 'Promotion',
    title: 'クーポン・タイムセール・まとめ買い',
    description: '割引クーポンの配布や期間限定のタイムセールで、購買意欲を効果的に刺激します。',
    image: couponImage,
    variant: 'warm',
    checks: [
      '割引率(%)・値引き(円)クーポン配布',
      '開始・終了日を設定したタイムセール',
      '同一商品まとめ買い割引',
    ],
  },
  {
    tag: 'Point System',
    title: 'ポイント・ポイントセール',
    description: '商品ごとのポイント付与率を設定し、リピーターを増やす仕組みを簡単に構築。',
    image: pointImage,
    variant: 'cool',
    checks: [
      '商品別ポイント付与率の設定',
      '通常ポイントに追加付与するセール機能',
    ],
  },
  {
    tag: 'Communication',
    title: 'メルマガ配信',
    description: 'タイムセールや新商品の入荷情報をメールマガジンで配信。顧客との接点を維持します。',
    image: mailMagazineImage,
    variant: 'soft',
    checks: [
      'かんたんメルマガ作成・配信',
      'セール・入荷通知に最適',
    ],
  },
  {
    tag: 'Analytics',
    title: 'ダッシュボード・レビュー',
    description: '売上・注文数・平均単価を期間別に確認。購入者レビューで商品の信頼度もアップ。',
    image: dashboardImage,
    variant: 'fresh',
    checks: [
      '売上・注文数・平均単価の期間別確認',
      '購入者による評価・コメント機能',
    ],
  },
];

const subFeatures = [
  { title: 'Google自動フィード', description: '商品情報を自動連携しリスティングを最新に', image: dashboardImage },
  { title: 'Googleタグマネージャー', description: '管理画面からかんたん連携', image: dashboardImage },
  { title: 'Googleサーチコンソール', description: '検索パフォーマンスの改善に', image: dashboardImage },
  { title: 'SNS設定', description: 'Instagram・X・Facebookの連携', image: reviewImage },
  { title: 'TikTok商品投稿', description: 'TikTokに商品情報を自動投稿', image: reviewImage },
  { title: 'Instagramショップ', description: 'ショップ開設をサポート', image: reviewImage },
];

const MarketingSection = () => {
  const hero = mainFeatures[0];
  const cards = mainFeatures.slice(1);

  return (
    <section className={Style.marketing}>
      <SectionHeader
        eyebrow="Marketing &amp; Sales"
        title="商品を売る"
        sub="集客・販促・分析まで、売上を伸ばすための機能が充実。"
      />

      {/* Hero Card */}
      <div className={Style.marketing__hero}>
        <div className={Style.marketing__heroImg}>
          <img src={hero.image} alt={hero.title} />
        </div>
        <div className={Style.marketing__heroBody}>
          <span className={Style.marketing__heroTag}>{hero.tag}</span>
          <h3 className={Style.marketing__heroTitle}>{hero.title}</h3>
          <p className={Style.marketing__heroDesc}>{hero.description}</p>
          <ul className={Style.marketing__heroChecks}>
            {hero.checks.map((check, i) => (
              <li key={i}>{check}</li>
            ))}
          </ul>
        </div>
      </div>

      {/* Sub Cards */}
      <div className={Style.marketing__cardRow}>
        {cards.map((feat, index) => (
          <div key={index} className={Style.marketing__card}>
            <div className={Style.marketing__cardImg}>
              <img src={feat.image} alt={feat.title} />
            </div>
            <div className={Style.marketing__cardBody}>
              <span className={Style.marketing__cardTag}>{feat.tag}</span>
              <h3 className={Style.marketing__cardTitle}>{feat.title}</h3>
              <div className={Style.marketing__cardDivider} />
              <p className={Style.marketing__cardDesc}>{feat.description}</p>
              <ul className={Style.marketing__cardChecks}>
                {feat.checks.map((check, i) => (
                  <li key={i}>{check}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      <div className={Style.marketing__subHeader}>
        <div className={Style.marketing__subEyebrow}>Integrations</div>
        <div className={Style.marketing__subTitle}>外部連携・SNS</div>
      </div>

      <div className={Style.marketing__subGrid}>
        {subFeatures.map((item, index) => (
          <div key={index} className={Style.marketing__subCard}>
            <div className={Style.marketing__subIcon}>
              <img src={item.image} alt={item.title} />
            </div>
            <div>
              <div className={Style.marketing__subCardTitle}>{item.title}</div>
              <div className={Style.marketing__subCardDesc}>{item.description}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

const Func = () => {
  return (
    <>
      <TopView />
      <ShopSetupSection />
      <ProductSetupSection />
      <MarketingSection />
      <PaymentMethod />
      <FuncSectionBlock title="アプリ" items={comachiApps} subTitle={appsDescreption}/>
    </>
  );
};

export default Func;
